import { render, staticRenderFns } from "./six.vue?vue&type=template&id=248032ce&scoped=true&"
import script from "./six.vue?vue&type=script&lang=js&"
export * from "./six.vue?vue&type=script&lang=js&"
import style0 from "./six.vue?vue&type=style&index=0&id=248032ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248032ce",
  null
  
)

export default component.exports